export class UserSelect {
    mode!: UserSelectMode;
    clear?: boolean;
    multiple?: boolean;
    selectedId?: string[];
    allowNull?: boolean;
    required?: boolean;
}

export enum UserSelectMode {
    DAI = 0,
    STAFF = 1
}